export function calcPercent(amount: number, percent: number) {
    return (percent / 100) * amount;
}

export function numberOrZero(value?: number): number {
    return value || 0;
}